import {makeStyles} from "@material-ui/core/styles";

export const useSimpleTableStyles = makeStyles(() => ({
    row: {
        '& .MuiTableCell-root': {
            padding: '16px 0 16px 14px'
        }
    }
}));
